var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "m18 8 5 4-5 4v-3h-4v-2h4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M4.154 2h9.692C15.034 2 16 2.997 16 4.222v4.445h-2.154V4.222H4.154v15.556h9.692v-4.445H16v4.445C16 21.003 15.034 22 13.846 22H4.154C2.966 22 2 21.003 2 19.778V4.222C2 2.997 2.966 2 4.154 2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M9 11c-2 0-2-.626-2-1 0-.484.701-1 2-1 1.185 0 1.386.638 1.4 1.018l1-.018h1c0-1.026-.666-2.469-2.4-2.879V6.012H8v1.073C6.029 7.416 5 8.712 5 10c0 1.12.52 3 4 3 2 0 2 .676 2 1 0 .415-.62 1-2 1-1.841 0-1.989-.857-2-1H5c0 .918.661 2.553 3 2.92V18h2v-1.085c1.971-.331 3-1.627 3-2.915 0-1.12-.52-3-4-3"
})));
export default SvgOut;